export default {
  title: 'Vérification de votre identité',
  subTitle: ' Nous vous avons envoyé un courriel de vérification.\nSaisir le code de ce courriel dans la case ci-dessous.',
  form: {
    fields :{
      code: {
        label: 'Saisir le code à 6 chiffres',
      },
    },
    btnSubmit: 'Vérifier',
  }
};
